export const homePageName = 'home';
export const setPasswordPageName = 'set-password';
export const forgotPasswordPageName = 'forgot-password';
export const changePasswordPageName = 'change-password';
export const editProfilePageName = 'edit-profile';
export const loginPageName = 'login';
export const statusDashboardPageName = 'status-dashboard';
export const servicesAdministrationPageName = 'services-administration';
export const incidentsAdministrationPageName = 'incidents-administration';
export const popupsAdministrationPageName = 'popups-administration';
export const serviceClientsAdministrationPageName = 'service-clients-administration';

